import React, { useEffect, useRef, useState } from "react";
import PropTypes from "prop-types";
import classNames from "classnames";
import Link from "../../../link/link";
import RichText from "@default/general-components/rich-text";
import MediaSwitch from "../../../media-switch";

const ParagraphTeaserImage = ({ content }) => {
  const sectionClassNames = classNames({
      "paragraph paragraph-teaser-image": true,
    }),
    containerClassNames = classNames({
      container: true,
      "force-max-width": !content?.fieldUseMaxWidth,
    });

  const teaserModule = useRef(null);
  const [linkHovered, setLinkHovered] = useState(false);
  // set a shadow element for hover of links, since we need the other elements for border and icon.
  useEffect(() => {
    // get all links inside of the text module
    let links = teaserModule?.current.querySelectorAll("a");

    // Loop through all links, but only get highlighted Links and Downloads
    [...links].map((link) => {
      if (
        link.getElementsByClassName("highlighted-link")[0] ||
        link.dataset.entityType === "media"
      ) {
        // Create a span that can work as a background blur hover effect and append it to the links span-child.
        let hoverElement = document.createElement("span");

        hoverElement.classList.add("hover-element");

        if (link?.querySelector("span")) {
          link?.querySelector("span").appendChild(hoverElement);
          link?.classList.add("highlighted-link-wrapper");
        } else {
          link?.appendChild(hoverElement);
        }
      }
    });
  }, []);

  return (
    <section
      className={sectionClassNames}
      data-darkmode={content.fieldDarkMode}
      ref={teaserModule}
    >
      <div className={containerClassNames}>
        <div
          className={classNames({
            row: true,
            "image-left": content.fieldImagePosition === "left",
            "image-right flex-row-reverse":
              content.fieldImagePosition === "right",
          })}
        >
          <div
            className={classNames({
              "col-12 col-lg-6 image-col": true,
            })}
          >
            {content.fieldMultimediaSingle && (
              <div
                className={classNames("fading-image-hover-wrapper", {
                  active: linkHovered,
                })}
              >
                <MediaSwitch
                  media={content.fieldMultimediaSingle}
                  item={content.fieldMultimediaSingle}
                  autoplay={true}
                />
              </div>
            )}
          </div>
          <div
            className={classNames({
              "col-12 col-lg-6 text-col": true,
            })}
          >
            {content.fieldHeading && (
              <h2 className="headline-l">{content.fieldHeading}</h2>
            )}

            <RichText
              className="text"
              html={content.fieldText}
              pillSelectors={[
                ".highlighted-link",
                "a[data-entity-type='media']",
              ]}
            />
            {content.fieldCallToAction && (
              <Link
                className="learn-more action-element"
                link={content.fieldCallToAction}
                onMouseEnter={() => setLinkHovered(true)}
                onMouseLeave={() => setLinkHovered(false)}
                hoverAnimation={true}
              />
            )}
          </div>
        </div>
      </div>
    </section>
  );
};

ParagraphTeaserImage.propTypes = {
  viewMode: PropTypes.string,
  content: PropTypes.shape({
    fieldDarkMode: PropTypes.bool,
    fieldHeading: PropTypes.string.isRequired,
    fieldMultimediaSingle: PropTypes.shape({
      fieldMediaImage: PropTypes.shape({
        alt: PropTypes.string,
        title: PropTypes.string,
        style: PropTypes.shape({
          url: PropTypes.string.isRequired,
        }),
      }),
    }),
    fieldCallToAction: PropTypes.shape({
      title: PropTypes.string,
      uri: PropTypes.shape({
        path: PropTypes.string,
        __typename: PropTypes.string,
      }),
    }),
    fieldText: PropTypes.string,
    fieldImagePosition: PropTypes.oneOf(["left", "right"]),
  }),
};

export default ParagraphTeaserImage;
